import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CalendarIcon from '../../assets/icons/calendar.svg';
import Button from '../../ui/Button';
export const RallySessionsFilters = ({ startDate, endDate, setStartDate, setEndDate, }) => {
    const { t, i18n } = useTranslation();
    const startDateInputRef = useRef(null);
    const endDateInputRef = useRef(null);
    const formatDate = (dateStr) => {
        if (!dateStr) {
            return '';
        }
        const date = new Date(dateStr);
        return date.toLocaleDateString(i18n.language, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
    };
    const clearFilters = () => {
        setStartDate('');
        setEndDate('');
        if (startDateInputRef.current) {
            startDateInputRef.current.value = '';
        }
        if (endDateInputRef.current) {
            endDateInputRef.current.value = '';
        }
    };
    const handleStartDateClick = () => {
        if (startDateInputRef.current) {
            if (typeof startDateInputRef.current.showPicker === 'function') {
                startDateInputRef.current.showPicker();
            }
            else {
                startDateInputRef.current.focus();
            }
        }
    };
    const handleEndDateClick = () => {
        if (endDateInputRef.current) {
            if (typeof endDateInputRef.current.showPicker === 'function') {
                endDateInputRef.current.showPicker();
            }
            else {
                endDateInputRef.current.focus();
            }
        }
    };
    return (_jsxs("div", { className: "rally-sessions-filters", children: [_jsxs("div", { className: "filter-option", children: [_jsx("input", { type: "date", name: "start-date", max: new Date().toISOString().split('T')[0], ref: startDateInputRef, onChange: (event) => setStartDate(event.target.value) }), _jsx(Button, { variant: 'outlined', onClick: handleStartDateClick, label: startDate ? formatDate(startDate) : t('label.date_from'), icon: _jsx(CalendarIcon, {}), iconPosition: 'right', tabIndex: -1 })] }), _jsxs("div", { className: "filter-option", children: [_jsx("input", { type: "date", name: "end-date", max: new Date().toISOString().split('T')[0], ref: endDateInputRef, onChange: (event) => setEndDate(event.target.value) }), _jsx(Button, { variant: 'outlined', onClick: handleEndDateClick, label: endDate ? formatDate(endDate) : t('label.date_to'), icon: _jsx(CalendarIcon, {}), iconPosition: 'right', tabIndex: -1 })] }), _jsx(Button, { onClick: clearFilters, label: t('button.clear_filters') })] }));
};
export default RallySessionsFilters;
